module.exports = __webpack_public_path__ + "static/media/que-icon.f7e0a4e9.svg";